import React from 'react'
import FlexView from 'react-flexview/lib'
import { FirebaseService, FirebaseConfigKey } from '../../../../services/FirebaseService'
import { liabilityLimitPretty } from '../../../../services/utils'
import { isMobile } from 'react-device-detect'
import { LiabilityCoveragePopover } from '../../../Core/Popover/LiabilityCoveragePopover'

var classNames = require('classnames')

interface LiabilityProps {
    liabilityLimit: number,
    totalLiabilityPremium: number,
    isLiabilitySpecialPrice: boolean
}


export const Liability = ({ liabilityLimit, totalLiabilityPremium, isLiabilitySpecialPrice}: LiabilityProps) => {

    return (<>
            <FlexView className="space-between margin-bottom-basic">
                <div className="text-body bold black">Liability Coverage <LiabilityCoveragePopover/></div>
            </FlexView>
            <FlexView column={true} className={classNames({"space-between": !isMobile})}>
                <div className="black text-small">
                    {liabilityLimitPretty(liabilityLimit)} Liability limit
                </div>
                <div className="gray margin-top-small text-tiny">
                    Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                    {totalLiabilityPremium.toLocaleStringToFixed()}   
                        <br/>
                    {isLiabilitySpecialPrice && <div className="gray margin-top-small text-tiny">*Special Price</div>}
                        </div>
            </FlexView>

        </>
    )
}